<template>
  <div>
    <el-dialog
      title="审核通过"
      :visible="isShowAdoptDialog"
      width="600px"
      @open="init"
      @close="handleDialog"
      :close-on-click-modal="false"
    >
      <div v-loading="submitLoading">
        <div style="font-size: 16px; display: flex">
          <i
            class="el-icon-info"
            style="color: #e6a23c; font-size: 22px; margin-right: 6px"
          ></i
          >确定要审核通过？
        </div>
        <p>
          <el-form ref="form" :inline="true" :model="form" :rules="rules">
            <el-form-item
              label=""
              prop="amount"
              label-width="10px"
              v-if="type != 'withdraw'"
            >
              <el-input
                type="text"
                size="small"
                :formatter="$formatter.FenToYuan"
                v-model="form.amount"
                disabled
                style="width: 120px"
                placeholder="充值金额"
              ></el-input>
            </el-form-item>

            <el-form-item
              label=" = "
              prop="fromAmount"
              label-width="10px"
              v-if="type != 'withdraw'"
            >
              <el-input
                type="text"
                size="small"
                v-model="form.fromAmount"
                disabled
                style="width: 100px"
                placeholder="充币数量"
              ></el-input>
            </el-form-item>
            
            <el-form-item
              label="x 1 -"
              prop="feeRate"
              label-width="50px"
              v-if="type != 'withdraw'"
            >
              <el-input
                type="text"
                size="small"
                v-model="form.feeRate"
                style="width: 115px"
                placeholder="费率0.01-0.09"
                @blur="handleBlur($event)"
              ></el-input>
            </el-form-item>

            <el-form-item
              label=" x "
              prop="exchangeRate"
              label-width="30px"
              v-if="type != 'withdraw'"
            >
              <el-input
                type="text"
                size="small"
                v-model="form.exchangeRate"
                style="width: 90px"
                placeholder="汇率"
                @blur="handleBlur($event)"
                @input="val => handleInput(val, 'exchangeRate')"
              ></el-input>
            </el-form-item>

            <el-form-item
              label=""
              prop="amount"
              label-width="10px"
              v-if="type == 'withdraw'"
            >
              <el-input
                type="text"
                size="small"
                v-model="form.amount"
                disabled
                style="width: 100px"
                placeholder="提现金额"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="= "
              prop="fromAmount"
              label-width="10px"
              v-if="type == 'withdraw'"
            >
              <el-input
                type="text"
                size="small"
                v-model="form.fromAmount"
                disabled
                style="width: 90px"
                placeholder="提币数量"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="x "
              prop="exchangeRate"
              label-width="30px"
              v-if="type == 'withdraw'"
            >
              <el-input
                type="text"
                size="small"
                v-model="form.exchangeRate"
                style="width: 100px"
                placeholder="汇率"
                @blur="handleBlur($event)"
                @input="val => handleInput(val, 'exchangeRate')"
              ></el-input>
            </el-form-item>
            
            <!-- <el-form-item v-if="type == 'withdraw'" label="是否自动打款">
            <el-select
              v-model="form.automaticSend"
              filterable
              placeholder="--请选择--"
              :popper-append-to-body="false"
              popper-class="eloption"
            >
              <el-option label="自动" value="01"></el-option>
              <el-option label="手动" value="00"></el-option>
            </el-select>
          </el-form-item> -->


            <el-form-item
              label="打款账号"
              prop="paymentAccount"
              v-if="type == 'withdraw'"
            >
              <el-input
                type="text"
                size="small"
                style="width: 350px"
                placeholder="请输入42位发起账号"
                v-model="form.paymentAccount"
                show-word-limit
                maxlength="42"
              ></el-input>
            </el-form-item>
            
            <el-form-item label="备注111" prop="approveRemark">
              <el-input
                type="textarea"
                placeholder="请输入备注"
                v-model="form.approveRemark"
                style="width: 200%"
              ></el-input>
            </el-form-item>
          </el-form>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    isShowAdoptDialog: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        amount: '',
        fromAmount: '',
        paymentAccount: 'TBUgCfVvjdM48LAaGwu9wF1vvUe4diK3iB',
        orderId: '',
        status: '01',
        automaticSend:'01',
        approveRemark: '',
        feeRate: '0.02',
        exchangeRate: '',
      },
      submitLoading: false,
      rules: {
        // paymentAccount: [
        //   { required: true, message: '请输入42位账号', trigger: 'blur' },
        //   { min: 34, max: 42, message: '请输入42位账号', trigger: 'blur' },
        // ],
        approveRemark: [
          { required: true, message: '请输入通过原因', trigger: 'blur' },
        ],
        feeRate: [
          { required: true, message: '请输入费率', trigger: 'blur' },
        ],
        exchangeRate: [
          { required: false, message: '请确认汇率', trigger: 'blur' },
          { min: 1, max: 5, message: '请确认汇率', trigger: 'blur' }
        ],
      },
    }
  },
  methods: {
    init() {
      this.form.orderId = this.id

      if(!this.item.amount) {
        this.form.amount = ""
      } else {
        this.form.amount = this.$formatter.FenToYuan(null, null, this.item.amount, null)
      }

      this.form.fromAmount = this.item.fromAmount ? this.item.fromAmount : 0
      this.form.exchangeRate = this.item.exchangeRate ? this.item.exchangeRate + "##" : ""
    },
    handleDialog() {
      this.form = {
        amount: '',
        fromAmount: '',
        orderId: '',
        status: '01',
        automaticSend:'01',
        approveRemark: '',
        paymentAccount: 'TBUgCfVvjdM48LAaGwu9wF1vvUe4diK3iB',
        feeRate: '0.02',
        exchangeRate: '',
      }
      this.$refs['form'].resetFields()
      this.$emit('update:isShowAdoptDialog', false)
    },
    handleBlur(e) {
      if (
        (this.type != 'withdraw' &&
          this.form.feeRate &&
          this.form.exchangeRate) ||
        (this.type == 'withdraw' && this.form.exchangeRate)
      ) {
        this.submitLoading = true
        this.$axios
          .get('/depositWithdraw/cal_amount', {
            params: {
              orderId: this.form.orderId,
              type: this.type == 'withdraw' ? '01' : '00',
              amount: this.form.amount * 100,
              fromAmount: this.form.fromAmount,
              feeRate: this.form.feeRate,
              exchangeRate: this.form.exchangeRate,
              paymentAccount: this.form.paymentAccount,
              automaticSend: this.form.automaticSend,
            },
          })
          .then(res => {
            if (res.code != 200) {
              this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
                this.submitLoading = false
                return;
            }

            this.form = Object.assign({}, res.data)
            this.form.amount = this.$formatter.FenToYuan(null, null, res.data.amount, null)
            this.submitLoading = false
          })
      }
    },
    handleInput(val, type) {
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let params = {
            ...this.form,
            orderId: this.id,
            status: '01',
            amount: this.form.amount * 100,
          }
          this.$axios
            .post('/depositWithdraw/approveDepositWithdraw', params)
            .then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
                this.$emit('update:isShowAdoptDialog', false)
                this.$bus.$emit('refresh') //通知刷新
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
</style>